import { Controller } from "@hotwired/stimulus"

// Przeładowanie formularza po wybraniu opcji w selekcie: wysyła cały formularz POSTem
// pod wskazany adres, z wybraną wartością w parametrze (np. wybór szablonu nowego zadania).
// Idzie cały formularz, żeby serwer odtworzył to, co user już wpisał, i uzupełnił tylko braki.
export default class extends Controller {
  static values = { url: String, param: String }

  // Zwraca adres przeładowania z podmienionym parametrem (pusta opcja parametr usuwa).
  reloadUrl() {
    const url = new URL(this.urlValue, window.location.origin)
    if (this.element.value) {
      url.searchParams.set(this.paramValue, this.element.value)
    } else {
      url.searchParams.delete(this.paramValue)
    }

    return url.toString()
  }

  reload() {
    const form = this.element.form
    if (!form) return

    form.action = this.reloadUrl()
    // Turbo wysyła formularz fetchem (z tokenem CSRF), a serwer odpowiada turbo_streamem
    // podmieniającym sam formularz - strona się nie przeładowuje
    form.requestSubmit()
  }
}
